var render = function render(){var _vm=this,_c=_vm._self._c;return _c('centered',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center pt-5"},[_c('h2',[_vm._v(_vm._s(_vm.$t('common.page-not-found')))]),_vm._v(" "),_c('router-link',{attrs:{"to":_vm.backUrl}},[_c('base-button',{attrs:{"type":"primary"}},[_vm._v(_vm._s(_vm.$t('common.go-back-home')))])],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }